import { createFileRoute } from '@tanstack/react-router';

import { WorkspaceAssessmentListScreen } from '@/features/assessments/components/workspace/AssessmentListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/assessments/')({
  beforeLoad: () => {
    requirePermission('assessment:read');
  },
  component: WorkspaceAssessmentListScreen,
  staticData: { crumb: 'Assessments' },
});
